import { useEffect, useMemo, useRef } from 'react'

export function useCallbackRef<T extends (...args: any[]) => any>(callback: T) {
  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
  })

  return useMemo(
    () =>
      (...args: unknown[]) =>
        callbackRef.current?.(...args),
    [],
  )
}
